import React, { memo, useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { ApiError } from "../../services/api-errors";
import { moduleSettings } from "../../stores/module-settings.store";
import { LoaderDots } from "../loader/loader-dots";
import { requestParamsImpl } from "../../services/request-params.service";
import { useLocation, useParams } from "react-router-dom";
import { UrlParams } from "../../types";
import { ApiErrorView } from "../errors/api-error-view";

import { NewsletterMainLayout } from "./newsletter-main-layout";

const NewsletterLayout = () => {
    const { t } = useTranslation();
    const location = useLocation();
    let searchParams = new URLSearchParams(location.search);
    const [apiError, setApiError] = useState<ApiError>();
    const [moduleInitialized, setModuleInitialized] = useState(false);
    const urlParams = useParams<UrlParams>();
    requestParamsImpl.set(urlParams, searchParams);
    useEffect(() => {
        moduleSettings.initModuleSettings().subscribe(
            () => {
                setModuleInitialized(true);
                document.title =
                    moduleSettings.getRestaurantName() + " - " + t("instabook.newsletter");
            },
            (e: ApiError) => {
                setApiError(e);
            }
        );
    }, []);
    if (!moduleInitialized && !apiError) {
        return <LoaderDots />;
    }
    const content = apiError ? (
        <ApiErrorView error={apiError} />
    ) : (<NewsletterMainLayout />
    );
    return <>{content}</>
};

export const Newsletter = memo(NewsletterLayout)